import React, { useState, useEffect, useRef } from 'react'
import { Button } from 'primereact/button'
import { ProgressBar } from 'primereact/progressbar'
import { Steps } from 'primereact/steps'
import { Dialog } from 'primereact/dialog'
import { useHistory } from 'react-router-dom'
import { confirmDialog } from 'primereact/confirmdialog'
import {isMobile} from 'react-device-detect'
/*
   author: SICA SALVATORE e MASSIMO RATTI
PROPS da definire nell'istanza di Wizardbase:
- onExit = function handler sull'uscita del wizard ( TIPICAMENTE una navigazione verso un'altra pagina)
- onWizardComplete = function handler che viene triggerato solo al completamento del Wizard 
  ( a fronte della pressione dell'ultimo next ovvero del tasto CONCLUDI)
  potrebbe trattarsi del salvataggio dei dati oppure l'azione per mostrare un resoconto se si vuole mostrarlo sganciato dal dialog del wizard
- msgConfirmExit = messaggio nel CONFIRM chiusura Wizard se tralasciato non verrà chiesto nulla ed eseguita la onAbortWizard
- errorMsg = se si usano dei box di errore negli step passare lo state dell'errore
- setErrorMsg = se si usano dei box di errore negli step passare la function per settare lo state dell'errore
- visible = per comandare dalle props (quindi da componente padre) la visibilita del dialog
- OGNI PROP definita del Wizard sarà disponibile all'interno degli STEPS
- onStepChange = event handler cambio STEP
*/
export const WizardBase = (props) => {
    
    const [dialogVisible, setDialogVisible] = useState(
        props.visible !== undefined ? props.visible : true
    )
    const [currentStep, setCurrentStep] = useState(1)
    let history = useHistory()
    let historyBlocker = useRef()
    
    // aggiungo il listen alla history per mostrare una confirm se viene cambiata route
    // in maniera tale da lanciare la confirm nel momento in cui si cerca di uscire dal wizard

    useEffect(() => {
        if (props.msgConfirmExit) {
            historyBlocker.current = history.block((location, action) => {
                _confirmExit()
                return false
            })
            return () => {
               
                _unmountHistoryBlock()
            }
        }
    }, [])
    useEffect(() => {
        if (
            props.dialogVisible !== undefined &&
            props.dialogVisible &&
            !dialogVisible
        ) {
            setDialogVisible(true)
        }
        //})
    }, [props.dialogVisible])
    const _unmountHistoryBlock = async () => {
        if (props.msgConfirmExit && historyBlocker) {
          
            await historyBlocker.current()
          
        }
    }

    const _confirmExit = () => {
        if (!props.msgConfirmExit) props.onExit()
        else {
            confirmDialog({
                message: props.msgConfirmExit,
                header: 'Confirmation',
                icon: 'pi pi-exclamation-triangle',
                accept: async () => {
                    _unmountHistoryBlock()
                    props.onExit()
                }
            })
        }
    }
    // sezione stepper / progress bar

    let stepper
    if (isMobile) {
        let perc = props.steps ? (currentStep / props.steps.length) * 100 : 0
        stepper = (
            <div>
                <ProgressBar value={perc} showValue={false} />
                <div>
                    {props.steps ? props.steps[currentStep - 1].label : null}
                </div>
            </div>
        )
    } else {
        stepper = (
            <div className='stepper-box'>
                <Steps model={props.steps} activeIndex={currentStep - 1} onSelect={(e) => setCurrentStep(e.index+1)} readOnly={false}   />
            </div>
        )
    }

    //PULSANTI NAVIGAZIONALI
    const _next = async () => {
        if (currentStep < props.steps.length) {
            if (props.setErrorMsg) props.setErrorMsg(null)
            setCurrentStep(currentStep + 1)
            if (props.onStepChange) props.onStepChange(currentStep)
        } else {
            _unmountHistoryBlock()
            if (props.onWizardComplete) props.onWizardComplete()
            //setDialogVisible(false)
        }
    }

    const _prev = () => {
        if (currentStep > 1) {
            setCurrentStep(currentStep - 1)
        }
    }

    const handleKeyDown = (evt) => (evt.which === 13 ? _next() : {})

    const footer = (
        <div>
            <Button
                label="Indietro"
                disabled={currentStep > 1 ? '' : 'disabled'}
                className='p-button-raised p-button-rounded p-button-action'
                onClick={_prev}
            />

            <Button
                label={
                    props.steps && currentStep >= props.steps.length
                        ? "Concludi"
                        : "Avanti"
                }
                disabled={props.errorMsg && props.errorMsg !== ''}
                className='p-button-raised p-button-rounded p-button-action'
                onClick={_next}
            />
        </div>
    )

    const CurrentStep = props.steps
        ? props.steps[currentStep - 1].component
        : null
    const onDialogHide = props.onExit
        ? props.onExit
        : () => {
             
          }

    return (
        <div onKeyDown={handleKeyDown}>
            <Dialog
                id='dialogVisible'
                maximized={true}
                footer={footer}
                visible={dialogVisible}
                //style={{ width: '1450px', height: '850px' }}
                header={stepper}
                modal
                blockScroll={true}
                draggable={false}
                onHide={onDialogHide}
                className='dialog-full-page p-fluid'
            >
                <div>
                    {CurrentStep
                        ? React.cloneElement(CurrentStep, { ...props })
                        : null}
                </div>
            </Dialog>
        </div>
    )
}
